// Per-category landmark icons + labels for React UI (map inspector, detail
// pages, lists). The map's raster markers in components/map/AtlasMap.tsx draw
// the same glyph set on canvas — keep the two visually aligned when changing
// either.

import React from "react";
import {
  Triangle,
  Droplet,
  Eye,
  Home,
  Tent,
  Hotel,
  CircleDashed,
  Landmark,
  Flag,
} from "lucide-react";

export const LANDMARK_CATEGORY_LABELS: Record<string, string> = {
  trig_point: "Trig point",
  waterfall: "Waterfall",
  viewpoint: "Viewpoint",
  bothy: "Bothy",
  shelter: "Shelter",
  mountain_hut: "Mountain hut",
  stone_circle: "Stone circle",
  bridge: "Bridge",
  cave: "Cave",
};

/** Every known category, in display order (the label map's key order). */
export const LANDMARK_CATEGORIES: string[] = Object.keys(LANDMARK_CATEGORY_LABELS);

export function landmarkCategoryLabel(category: string | null | undefined): string {
  return (category && LANDMARK_CATEGORY_LABELS[category]) ?? "Landmark";
}

// Hand-drawn cave mouth (lucide has no cave): ground line + arched entrance.
// Same path data as the cave map glyph in components/map/AtlasMap.tsx.
function CaveIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 21h20" />
      <path d="M5 21v-8.5a7 7 0 0 1 14 0V21" />
    </svg>
  );
}

export function landmarkCategoryIcon(
  category: string | null | undefined,
  size: number,
): React.ReactNode {
  const p = { size };
  switch (category) {
    case "trig_point": return <Triangle {...p} />;
    case "waterfall": return <Droplet {...p} />;
    case "viewpoint": return <Eye {...p} />;
    case "bothy": return <Home {...p} />;
    case "shelter": return <Tent {...p} />;
    case "mountain_hut": return <Hotel {...p} />;
    case "stone_circle": return <CircleDashed {...p} />;
    case "bridge": return <Landmark {...p} />;
    case "cave": return <CaveIcon size={size} />;
    default: return <Flag {...p} />;
  }
}
